import HTTP from '@/common/http'

export default {
  state: {
    contracts: [],
    activeId: null,
    activeType: null,
    groups: []
  },
  getters: {
    contracts: state => {
      return state.contracts
    },
    groups: state => {
      return state.groups
    },
    activeId: state => {
      return state.activeId
    },
    activeType: state => {
      return state.activeType
    }
  },
  mutations: {
    SET_CONTRACTS (state, contracts) {
      state.contracts = contracts
      if (!state.activeId) {
        state.activeId = contracts[0]
        state.activeType = 'contract'
      }
    },
    SET_GROUPS (state, groups) {
      state.groups = groups
    },
    SET_ACTIVE_ID (state, activeId) {
      state.activeId = activeId
    },
    SET_ACTIVE_TYPE (state, activeId) {
      if (state.groups.includes(activeId)) {
        state.activeType = 'group'
      } else if (state.contracts.includes(activeId)) {
        state.activeType = 'contract'
      }
    }
  },
  actions: {
    GET_CONTRACTS (context) {
      HTTP.get('/contracts')
        .then(response => {
          if (response.data) {
            let contracts = response.data.contracts.map(contract => contract.id)
            contracts.sort()
            context.commit('SET_CONTRACTS', contracts)
            let groups = response.data.groups.map(group => group.id)
            groups.sort()
            context.commit('SET_GROUPS', groups)
          }
        })
    },
    SET_ACTIVE (context, activeId) {
      context.commit('SET_ACTIVE_ID', activeId)
      context.commit('SET_ACTIVE_TYPE', activeId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contracts/index.js